// v11 §2H (BOLT-028) — the host's one-screen setup state. The first-hider
// pick now lives IN the lobby; when the server opens the `firsthider` phase
// the client auto-sends `choose_first_hider` with this pre-selection, so the
// standalone screen never needs a tap (the wire is untouched).
import { useSyncExternalStore } from 'react';
import type { Team } from '../../shared/series';

export type FirstHiderChoice = Team | 'random';

// v28 BOLT-138 (Jake): "The default is random in the middle." The slider's
// middle detent IS the default, which is what makes random read as neutral
// rather than as a third thing somebody has to pick.
//
// NB the ticket's acceptance row said this "matches today's default". It did
// not: today's default was 'A', the creator. This is a real behaviour change,
// and it is Jake's stated intent, so it ships - but any test that depends on
// WHO hides first now has to say so rather than lean on the default.
let choice: FirstHiderChoice = 'random';
const listeners = new Set<() => void>();

export const setupStore = {
  get(): FirstHiderChoice {
    return choice;
  },
  setFirstHider(c: FirstHiderChoice): void {
    choice = c;
    for (const l of listeners) l();
  },
};

export function useFirstHiderChoice(): FirstHiderChoice {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => choice,
  );
}
